import { alpha } from '@material-ui/core';
import { Avatar, Box, Typography } from '@mui/material';

const PrescriptionSectionHeader = ({ number, title }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                pb: 1,
                borderBottom: '1px solid',
                borderColor: 'divider',
            }}
        >
            <Avatar
                sizes="large"
                sx={{
                    width: 24,
                    height: 24,
                    bgcolor: (theme) => alpha(theme.palette.primary.main, 0.12),
                    color: 'primary.main',
                    fontSize: '1rem',
                    mr: 1.5,
                }}
            >
                {number}
            </Avatar>
            <Typography
                variant="h6"
                color="primary.main"
                sx={{
                    fontSize: '1.125rem',
                    fontWeight: 600,
                }}
            >
                {title}
            </Typography>
        </Box>
    );
};
export default PrescriptionSectionHeader;
